import React from "react";
import { useLang } from "@/i18n";

export default function LanguageToggle() {
  const { lang, setLang } = useLang();
  const opt = (v, label) => (
    <button
      key={v}
      data-testid={`lang-${v}`}
      onClick={() => setLang(v)}
      className={`px-3 py-1 font-mono-data text-[11px] tracking-[0.2em] uppercase transition-all border ${
        lang === v
          ? "border-[#00D4FF] text-[#03040B] bg-[#00D4FF]"
          : "border-white/15 text-white/70 hover:border-white/40"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div className="inline-flex items-center gap-1" data-testid="language-toggle">
      {opt("en", "EN")}
      {opt("pt", "PT")}
    </div>
  );
}
